import { render, staticRenderFns } from "./PaymentSuccess.vue?vue&type=template&id=d4c955c6&scoped=true"
import script from "./PaymentSuccess.vue?vue&type=script&lang=js"
export * from "./PaymentSuccess.vue?vue&type=script&lang=js"
import style0 from "./PaymentSuccess.vue?vue&type=style&index=0&id=d4c955c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c955c6",
  null
  
)

export default component.exports